var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfafffunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pfafffunk_svg__Rectangle_3254",
    width: 227,
    height: 227,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pfafffunk_svg__logo-dorffunk",
    transform: "translate(-2491 -3945)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pfafffunk_svg__Rectangle_3254)",
    transform: "matrix(1, 0, 0, 1, 2491, 3945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pfafffunk_svg__Rectangle_3254-2",
    width: 209,
    height: 209,
    fill: "#b6224c",
    rx: 30,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pfafffunk_svg__DorfFunk",
    transform: "translate(2519.82 3981.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pfafffunk_svg__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Rectangle",
    fill: "#dd3c5d",
    fillRule: "evenodd",
    d: "M4.41,4.962h99.013V33.91H4.41Z",
    transform: "translate(10.954 12.326)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pfafffunk_svg__Rectangle-2",
    width: 99.013,
    height: 15.325,
    fill: "#b1c800",
    transform: "translate(15.364 57.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Rectangle-3",
    fill: "#66bfac",
    fillRule: "evenodd",
    d: "M4.41,12.5h99.013V27.825H4.41Z",
    transform: "translate(10.954 31.047)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pfafffunk_svg__Group_1869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Shape",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M86.416,20.247c-4.138,28.592-26.9,49.26-54.145,49.26H23.3L21.58,71.23c6.208,11.368,17.589,18.6,30,18.6h8.622l17.244,18.257a6.367,6.367,0,0,0,4.138,1.722,4.379,4.379,0,0,0,2.069-.344,6.469,6.469,0,0,0,3.794-5.512V89.143c16.209-3.445,28.28-18.6,28.28-36.859.69-18.6-12.071-34.1-28.624-36.859A23.237,23.237,0,0,1,86.416,20.247Z",
    opacity: 0.346,
    transform: "translate(53.602 38.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Shape-2",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M132.431,49.949C132.431,22.391,111.739,0,86.218,0H46.213C20.692,0,0,22.391,0,49.949c0,24.8,16.209,45.126,38.281,49.26v21.013a6.805,6.805,0,0,0,4.138,6.2,5.875,5.875,0,0,0,2.414.344,6.813,6.813,0,0,0,4.828-2.067l23.8-25.147H85.873c23.106.344,42.419-17.568,45.868-42.026A61.8,61.8,0,0,0,132.431,49.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Path",
    fill: "#6343c5",
    fillRule: "evenodd",
    stroke: "#6343c5",
    strokeWidth: 0.805,
    d: "M77.143,8.28a3.707,3.707,0,0,1,3.449,3.445,3.256,3.256,0,0,1-3.449,3.445H11.962a3.707,3.707,0,0,1-3.449-3.445C8.858,10,10.237,8.28,11.962,8.28Z",
    transform: "translate(21.146 20.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Path-2",
    fill: "#ee335f",
    fillRule: "evenodd",
    stroke: "#ee335f",
    strokeWidth: 0.806,
    d: "M77.143,13.568a3.707,3.707,0,0,1,3.449,3.445,3.256,3.256,0,0,1-3.449,3.445H11.962a3.707,3.707,0,0,1-3.449-3.445c.345-1.722,1.724-3.445,3.449-3.445Z",
    transform: "translate(21.146 33.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfafffunk_svg__Path-3",
    fill: "#2cb775",
    fillRule: "evenodd",
    stroke: "#2cb775",
    strokeWidth: 0.805,
    d: "M11.962,25.683a3.707,3.707,0,0,1-3.449-3.445,3.256,3.256,0,0,1,3.449-3.445H50.932a3.707,3.707,0,0,1,3.449,3.445,3.454,3.454,0,0,1-3.449,3.445Z",
    transform: "translate(21.146 46.682)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfafffunk);
export default __webpack_public_path__ + "static/media/pfafffunk.b2e35059359f0d82acdbe92f9de02d71.svg";
export { ForwardRef as ReactComponent };